import { Icon } from 'design-system/icon';

import styles from './dropdown-indicator.module.scss';

const DropdownIndicator = () => <Icon name={'expand_more'} className={styles.indicator} />;

export { DropdownIndicator };
